import { render, staticRenderFns } from "./StockDetailSplitDialog.vue?vue&type=template&id=5e1ab370&scoped=true&"
import script from "./StockDetailSplitDialog.vue?vue&type=script&lang=js&"
export * from "./StockDetailSplitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1ab370",
  null
  
)

export default component.exports